import i18next from 'i18next';
import moment from 'app/modules/moment';
import { DateTime } from 'luxon';

// cache for default timezone to prevent repeated calls to Intl.DateTimeFormat().resolvedOptions()
let defaultTimezone: string | null = null;
export const getDefaultTimezone = () => {
	if (!defaultTimezone) {
		defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	}
	return defaultTimezone;
};

// regular display: "11/2/2017, 12:13:42 PM"
// friendlyDisplay: "November 2, 2017"
export const getLocalTime = (
	date: ConstructorParameters<typeof Date>[0],
	opts: Intl.DateTimeFormatOptions | boolean | 'noSeconds' = false,
	timezone = getDefaultTimezone(),
) => {
	try {
		const friendlyDisplayOptions = {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		} as Intl.DateTimeFormatOptions;

		const noSecondsOptions = {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		} as Intl.DateTimeFormatOptions;

		const options: Intl.DateTimeFormatOptions = {
			timeZone: timezone,
			...(opts === true ? friendlyDisplayOptions : opts === 'noSeconds' ? noSecondsOptions : opts || {}),
		};

		const localTime = new Date(date).toLocaleString(i18next.language, options);

		return localTime;
	} catch (error) {
		console.error('Error in getLocalTime:', error);
		return '';
	}
};

export const getCSVReportTime = (date: ConstructorParameters<typeof Date>[0], tenantTz: string) => {
	const localTime = new Date(date).toLocaleString(i18next.language, {
		timeZone: tenantTz,
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		fractionalSecondDigits: 3,
	});
	const date1 = new Date(localTime).getTime();
	const fmt = DateTime.fromMillis(date1, {
		locale: i18next.language,
		zone: tenantTz,
	});
	if (fmt.isValid as boolean) {
		return fmt.toString();
	}
	return new Date(date).getTime();
};

export const collabJobExpireTime = (date: number, tenantTimeZone: string) => {
	const formattedDate = getLocalTime(
		new Date(date),
		{
			month: '2-digit',
			day: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			timeZoneName: 'short',
		},
		tenantTimeZone,
	);

	return formattedDate.replaceAll('/', '-').split(',').join('');
};

export const collabExtensionExpireTime = (date: number, tenantTimeZone: string) => {
	return moment(date).format('MMMM D YYYY, h:mm A');
};
